import React, { Component, Fragment, Suspense } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fetchDocRecipientListAction } from "../../actions/DocumentActions";
import { LazyLoad } from "../../commonComponents";
import LZLoader from "../../commonComponents/LZLoader";

const AddRecipientsPopupLazy = LazyLoad(() =>
  import(
    /* webpackChunkName: "add-recipients-popup-modal" */ "../DocumentApprovalPopupNew/AddRecipientsPopup"
  ),
);
const DocStatusUpdatePopupLazy = LazyLoad(() =>
  import(
    /* webpackChunkName: "doc-status-update-popup-modal" */ "../DocumentApprovalPopupNew/DocStatusUpdatePopup"
  ),
);

class Collaborators extends Component {
  state = {
    showAddRecipientsPopup: false,
    showDocStatusUpdateModal: false,
    buttonValue: "forReviewer",
  };

  componentDidMount() {
    // fetch if receipients not present
    const {
      docRecipientList,
      docID,
      fetchDocRecipientListAction: fetchDocRecipientList,
    } = this.props;
    if (!(docRecipientList && docRecipientList.length && docID)) {
      fetchDocRecipientList(docID)
        .then(() => {})
        .catch(() => {});
    }
  }

  _getApprovers = collaboratorsData => {
    //
    const approvers = [];
    const approversId = {};
    for (let i = 0; i < collaboratorsData.length; i += 1) {
      const analysisData = collaboratorsData[i];
      if (analysisData.approvers) {
        for (let j = 0; j < analysisData.approvers.length; j += 1) {
          const newApprover = analysisData.approvers[j];
          // add to unique list of approvers
          if (!approversId[newApprover.id]) {
            approversId[newApprover.id] = true;
            approvers.push(newApprover);
          }
        }
      }
    }
    if (!approvers.length) {
      return null;
    }
    return approvers;
  };

  _onAddReviewerBlock = () => {
    this.setState({ showAddRecipientsPopup: true });
  };

  _toggleModalPopUp = (key, flag) => {
    this.setState({
      [key]: flag,
    });
  };

  _updateMultipleState = obj => {
    this.setState({
      ...obj,
    });
  };

  render() {
    const {
      collaboratorsData,
      currentView,
      docRecipientList, // recipients list goes away on refresh, bug!
      createdBy,
    } = this.props;
    const {
      name: docOwner,
      image_url: docOwnerProfileImageUrl,
      user_email: docOwnerEmail,
    } = createdBy;
    const approvers = this._getApprovers(collaboratorsData);

    return (
      <Fragment>
        {this.state.showAddRecipientsPopup && (
          <Suspense fallback={<LZLoader label="Please wait..." largeLabel />}>
            <AddRecipientsPopupLazy
              updateMultipleState={this._updateMultipleState}
              toggleModalPopUp={this._toggleModalPopUp}
            />
          </Suspense>
        )}
        {this.state.showDocStatusUpdateModal && (
          <Suspense fallback={<LZLoader label="Please wait..." largeLabel />}>
            <DocStatusUpdatePopupLazy
              buttonValue={this.state.buttonValue}
              docID={this.props.docID}
              documentStatus={this.props.documentStatus}
              toggleModalPopUp={this._toggleModalPopUp}
            />
          </Suspense>
        )}
        <div className="context-notes animated fadeinright">
          <div className="notes-header">
            <span
              data-test="collaborator-right-pane-title"
              className="right-pane-title">
              Team
            </span>
          </div>
          <div
            className={`collab-content collab-content-scroll-${currentView}`}>
            <div className="content-scroll">
              <div className="addproduct-info">
                You can see who all have access to this document and what their
                role is.
              </div>
              <div className="collab-container">
                <div
                  data-test="collaborator-section-title"
                  className="collab-section-subtitle">
                  Document Owner
                </div>
                <div
                  data-test="collaborators-deal-owner"
                  className="collab-deal-owner">
                  {/* <div
                data-test="collaborators-workflow-approver-info"
                className="collabworkflow-approver-info"> */}
                  <div
                    data-test="collaborators-workflow-approver-imgwrapper"
                    className="collabworkflow-approver-imgwrapper">
                    <img
                      data-test="collaborators-workflow-approver-img"
                      className="collabworkflow-approver-img"
                      src={docOwnerProfileImageUrl}
                      alt="Collaborators Profile"
                      height="32px"
                      width="32px"
                    />
                  </div>
                  <div
                    data-test="collaborators-deal-ownername-text"
                    className="collabworkflow-approver-namewrapper">
                    <div className="collaborator-deal-user-name">
                      {docOwner}
                    </div>
                    <div className="collaborator-deal-user-email">
                      {docOwnerEmail}
                    </div>
                  </div>
                  {/* </div> */}
                </div>
              </div>
              {/* Approvers list section */}
              <div className="collab-container">
                <div className="collab-section-subtitle">Approvers</div>
                {approvers ? (
                  approvers.map(approver => (
                    <div className="collab-deal-users">
                      <div className="collabworkflow-approver-imgwrapper">
                        <img
                          data-test="collaborators-workflow-approver-img"
                          className="collabworkflow-approver-img"
                          src={approver.image_url}
                          alt="Collaborators Profile"
                          height="32px"
                          width="32px"
                        />
                      </div>
                      <div
                        data-test="collaborators-deal-ownername-text"
                        className="collabworkflow-approver-namewrapper">
                        <div className="collaborator-deal-user-name">
                          {approver.name}
                        </div>
                        <div className="collaborator-deal-user-email">
                          {approver.user_email}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="collab-no-users-message">
                    <span className="collab-no-user-image">
                      <FontAwesomeIcon icon={["far", "comment-alt-check"]} />
                    </span>
                    No approvers added
                  </div>
                )}
              </div>

              {/* Recipient List */}
              <div className="collab-container">
                <div
                  data-test="collaborator-section-title"
                  className="collab-section-subtitle">
                  Collaborators
                </div>
                {docRecipientList && docRecipientList.length ? (
                  docRecipientList.map(({ user: receiver }) => (
                    <div className="collab-deal-users">
                      <div className="collabworkflow-approver-imgwrapper">
                        <img
                          data-test="collaborators-workflow-approver-img"
                          className="collabworkflow-approver-img"
                          src={receiver.image_url}
                          alt="Collaborators Profile"
                          height="32px"
                          width="32px"
                        />
                      </div>
                      <div
                        data-test="collaborators-deal-ownername-text"
                        className="collabworkflow-approver-namewrapper">
                        <div className="collaborator-deal-user-name">
                          {receiver.name}
                        </div>
                        <div className="collaborator-deal-user-email">
                          {receiver.user_email}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="collab-no-users-message">
                    <span className="collab-no-user-image">
                      <FontAwesomeIcon icon={["far", "user-friends"]} />
                    </span>
                    No collaborators added
                  </div>
                )}
              </div>
              <div
                className="add-another-signature-footer"
                data-test="add-another-signature-footer">
                <span
                  className="add-another-signer-wrapper"
                  data-test="add-another-signer-wrapper"
                  onClick={() => this._onAddReviewerBlock()}
                  onKeyPress={() => this._onAddReviewerBlock()}
                  role="button"
                  tabIndex="0">
                  <span
                    className="userrole-icon"
                    data-test="collaborators-add-reviewer-btn">
                    <FontAwesomeIcon icon={["fas", "user-plus"]} className="" />
                  </span>
                  <div
                    className="add-another-signer-btn"
                    data-test="add-another-signer-btn">
                    <div
                      className="add-another-signer-title"
                      data-test="add-another-signer-title">
                      Add another teammate
                    </div>
                    <div
                      data-test="collaborators-view-edit-btn"
                      className="add-another-signer-desc">
                      Give view or edit access for this document to your team
                      and collaborate with them
                    </div>
                  </div>
                </span>
              </div>
              {/* {docStatus !== "DRAFT" && collaboratorsData.length > 0 && (
              <div>
                <div className="collab-section-title">DEAL APPROVERS</div>
                {collaboratorsData.map(collabData => (
                  <CollabWorkflowBox
                    collabData={collabData}
                    docStatus={docStatus}
                    key={collabData.id}
                  />
                ))}
              </div>
            )} */}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    document: { id: docID, created_by: createdBy, documentStatus } = {},
    collaboratorsData,
    docRecipientList,
  } = state.DocumentStore;
  const { view: currentView } = state.QuotationStore;
  return {
    docID,
    createdBy,
    currentView,
    collaboratorsData,
    docRecipientList,
    documentStatus,
  };
};

const mapDispatchToProps = {
  fetchDocRecipientListAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Collaborators);
